import { ExtendedRouteConfig } from '@/router/types';
import SearchResults from './components/search-results/search-results.vue';
import OrderDetails from './components/order-details/order-details.vue';

export const orderSearchRoutes: ExtendedRouteConfig[] = [
  {
    name: 'order-search/search',
    path: '/auftragssuche',
    component: SearchResults,
    meta: {
      requiresAuth: true,
      title: 'Auftragssuche',
    },
  },
  {
    name: 'order-search/order-details',
    path: '/auftrag/:orderId',
    component: OrderDetails,
    meta: {
      requiresAuth: true,
      title: 'Auftragsdetails',
    },
  },
];
